{
  "comment": "Shared by scripts/build_data.py and the Worker. Tiles index curbs/garages/meters for lookup; cells hold the enforcement model. Changing these needs a data rebuild.",
  "origin": { "lat": 33.0, "lon": -119.0 },
  "tile": { "dlat": 0.01, "dlon": 0.01, "stride": 1000 },
  "cell": { "dlat": 0.00135, "dlon": 0.00163, "stride": 1000 },
  "bbox": { "lat0": 33.70, "lat1": 34.34, "lon0": -118.67, "lon1": -118.10 }
}
